import { Container, FormControlLabel, Grid, Radio } from "@mui/material";
import React, { useState } from "react";
import { UiNavBar } from "../../component/_uiComponents/UiNavbar";
import { UiDashboardWrapper } from "../../component/_uiComponents/UiDashboardWrapper";
import { UiDashboardContent } from "../../component/_uiComponents/UiDashboardContent";
import { UiSideBar } from "../../component/_uiComponents/UiSidebar";
import { UiTab } from "../../component/common/UiTab";
import { TabPanel } from "@mui/lab";
import { UiWhiteCard } from "../../component/common/UiWhiteCard";
import {
  UiButton,
  UiIconButton,
  UiTextIconButton,
} from "../../component/common/UiButton";
import { TransferIcon } from "../../../../styles/img/svg/TransferIcon";
import { BillIcon } from "../../../../styles/img/svg/BillIcon";
import { SettleCardIcon } from "../../../../styles/img/svg/SettleCardIcon";
import { UiFavouriteItem } from "../../component/common/UiFavouriteItem";
import DialogLogo from "../../../../styles/img/dialog-logo.png";
import Alogo from "../../../../styles/img/A-logo.png";
import { BookmarkIcon } from "../../../../styles/img/svg/BookmarkIcon";
import { UiActivities } from "../../component/_uiComponents/UiActivities";
import { UiCustomPopup, UiPopup } from "../../component/common/UiModal";
import { PassbookIcon } from "../../../../styles/img/svg/PassbookIcon";
import { UiDashboardCardSlider } from "../../component/_uiComponents/UiDashboardCardSlider";
import { UiRightSideModal } from "../../component/common/UiRightSideModal";
import { AccountDetail } from "../../component/_uiComponents/Accounts/AccountDetail";
import { FundTransferIcon } from "../../../../styles/img/svg/FundTransferIcon";

import { UiPassbookTable } from "../../component/_uiComponents/Tables/UiPassbookTable";
import { UiSelectMyAccount } from "../../component/_uiComponents/Dashboard/UiSelectMyAccount";
import { UiSelectMyCard } from "../../component/_uiComponents/Dashboard/UiSelectMyCard";
import { UiMobileBottomCard } from "../../component/_uiComponents/Dashboard/UiMobileBottomCard";
import { DfccCardIcon } from "../../../../styles/img/svg/Bills/DfccCardIcon";
import { OtherBankCardIcon } from "../../../../styles/img/svg/Bills/OtherBankCardIcon";
import { useNavigate } from "react-router-dom";
import { UiBillerFavouriteCard } from "../../component/_uiComponents/BillerFavourites/UiBillerFavouriteCard";
import { UiSearchForm } from "../../component/_uiComponents/Forms/UiSearchForm";
import { UiDashboardEmptyMessage } from "../../component/_uiComponents/ErrorMessages/UiEmptyScreens";
import emptyscreenDashboard from "../../../../styles/img/empty-accounts-db.png";

export const BillerFavouriteDashboardEmptyWithSearch = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openSideModal, setOpenSideModal] = useState(false);
  const [showPassbook, setShowPassbook] = useState(false);
  const [showMyAccounts, setShowMyAccounts] = useState(false);
  const [showMyCards, setShowMyCards] = useState(false);
  const [openCardTypeModal, setOpenCardTypeModal] = useState(false);

  const handleCloseModal = () => setOpenModal(false);

  const handleOpenModal = () => setOpenModal(true);

  const navigate = useNavigate();

  const toOwnCardBillPayment = () => {
    navigate("/ui/card-bill-payment-form-own-adhoc");
  };

  const toOtherBankCardBillPayment = () => {
    navigate("/ui/card-bill-payment-other-bank");
  };

  const toBillPay = () => {
    navigate("/ui/bill-payment-favourite-form");
  };

  const tabList = [
    {
      id: 1,
      label: "All",
      value: "1",
    },
    {
      id: 2,
      label: "Personal Payees",
      value: "2",
    },
    {
      id: 3,
      label: "Billers",
      value: "3",
    },
  ];

  return (
    <>
      <UiNavBar />
      <UiDashboardWrapper>
        <UiSideBar />
        <UiDashboardContent>
          <div className="df-db-left">
            <UiWhiteCard className="mt-0">
              <UiTab tabNav={tabList} className="df-db-tab-wrapper">
                <div className="biller-favourite-search">
                  <UiSearchForm />
                </div>

                <TabPanel value="1">
                  <UiDashboardEmptyMessage
                    icon={emptyscreenDashboard}
                    className="df-fs-empt df-empt-msg-acc"
                  >
                    <h3>Uh-oh!</h3>
                    <p>No results found for your search criteria.</p>
                  </UiDashboardEmptyMessage>
                </TabPanel>

                <TabPanel value="2" className="df-card-tab">
                  <UiDashboardEmptyMessage
                    icon={emptyscreenDashboard}
                    className="df-fs-empt df-empt-msg-acc"
                  >
                    <h3>Uh-oh!</h3>
                    <p>No results found for your search criteria.</p>
                  </UiDashboardEmptyMessage>
                </TabPanel>

                <TabPanel value="3" className="df-card-tab">
                  <UiDashboardEmptyMessage
                    icon={emptyscreenDashboard}
                    className="df-fs-empt df-empt-msg-acc"
                  >
                    <h3>Uh-oh!</h3>
                    <p>No results found for your search criteria.</p>
                  </UiDashboardEmptyMessage>
                </TabPanel>
              </UiTab>
            </UiWhiteCard>
          </div>

          <div className="df-db-right">
            <div className="df-icon-card-wrapper">
              <UiWhiteCard className="df-icon-card">
                <TransferIcon />
                <h5>Transfer</h5>
              </UiWhiteCard>

              <UiWhiteCard
                className="df-icon-card df-cursor-point"
                onClick={() => setOpenCardTypeModal(true)}
              >
                <BillIcon />
                <h5>Pay a Bill</h5>
              </UiWhiteCard>

              <UiWhiteCard className="df-icon-card">
                <SettleCardIcon />
                <h5>Settle a Card</h5>
              </UiWhiteCard>
            </div>

            <UiDashboardCardSlider />

            <UiWhiteCard className="df-play-again">
              <Grid container className="df-align-center mb-2">
                <Grid size={7}>
                  <h2 className="df-play-again__title">Pay Again</h2>
                </Grid>
                <Grid size={5} className="text-right">
                  <UiTextIconButton
                    icon={<BookmarkIcon />}
                    name="All Favourites"
                    className="df-primary-underlined-text-icon-btn"
                  />
                </Grid>
              </Grid>

              <UiFavouriteItem
                logo={Alogo}
                title="Ashan Fernando"
                description="A/C: 21930039100"
              />

              <UiFavouriteItem
                logo={DialogLogo}
                title="My Dialog 500"
                description="0777841608"
              />
              <UiFavouriteItem
                logo={Alogo}
                title="Ashan Fernando"
                description="A/C: 21930039100"
              />

              <UiFavouriteItem
                logo={DialogLogo}
                title="My Dialog 500"
                description="0777841608"
              />

              <UiFavouriteItem
                logo={Alogo}
                title="Ashan Fernando"
                description="A/C: 21930039100"
              />
            </UiWhiteCard>
          </div>

          <UiMobileBottomCard />
        </UiDashboardContent>
      </UiDashboardWrapper>

      <UiCustomPopup
        openModal={openModal}
        handleClose={handleCloseModal}
        showCloseIcon
        className="df-view-acc-actions-pp"
      >
        <div className="df-vertical-icon-card">
          <div className="df-vertical-icon-card__item">
            <div onClick={() => setShowPassbook(true)}>
              <PassbookIcon />
              <p>View Passbook</p>
            </div>
          </div>

          <div className="df-vertical-icon-card__item">
            <div>
              <FundTransferIcon />
              <p>Fund Transfer</p>
            </div>
          </div>

          <div className="df-vertical-icon-card__item">
            <div onClick={() => setOpenCardTypeModal(true)}>
              <BillIcon />
              <p>Pay a Bill</p>
            </div>
          </div>
        </div>
      </UiCustomPopup>

      {/* passbook popup */}
      <UiCustomPopup
        openModal={showPassbook}
        handleClose={() => setShowPassbook(false)}
        showCloseIcon
        className="df-showpb-pp"
      >
        <div className="df-passbook">
          <h2 className="df-popup-title">Passbook</h2>
          <UiPassbookTable />
        </div>
      </UiCustomPopup>

      {/* accounts modal */}
      <UiCustomPopup
        openModal={showMyAccounts}
        handleClose={() => setShowMyAccounts(false)}
        showCloseIcon
        className="df-my-account-pp"
      >
        <UiSelectMyAccount />
      </UiCustomPopup>

      {/* cards modal */}
      <UiCustomPopup
        openModal={showMyCards}
        handleClose={() => setShowMyCards(false)}
        showCloseIcon
        className="df-select-card-pp"
      >
        <UiSelectMyCard />
      </UiCustomPopup>

      {/* view account modal */}
      <UiRightSideModal
        openSideModal={openSideModal}
        handleClose={() => setOpenSideModal(false)}
      >
        <AccountDetail viewPassbook={() => setShowPassbook(true)} />
      </UiRightSideModal>

      <UiCustomPopup
        openModal={openCardTypeModal}
        handleClose={() => setOpenCardTypeModal(false)}
        showCloseIcon
        className="df-view-acc-actions-pp"
      >
        <div className="df-vertical-icon-card">
          <div className="df-vertical-icon-card__item">
            <div onClick={toOwnCardBillPayment}>
              <DfccCardIcon />
              <p>LOLC Credit Card</p>
            </div>
          </div>

          <div className="df-vertical-icon-card__item">
            <div onClick={toOtherBankCardBillPayment}>
              <OtherBankCardIcon />
              <p>Other Bank Credit Card</p>
            </div>
          </div>
        </div>
      </UiCustomPopup>
    </>
  );
};
